import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { ExerciseQuestionsFragmentDoc } from './ExerciseQuestions';
export type ExerciseQuestionResponseFragment = { questionId: string, responseType: Types.ResourceResponseTypeEnum, textResponse?: string | null, imageHotspotResponses?: Array<{ hotspots: Array<{ id: string, text: string }> }> | null, response?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, question?: { id: string, text: string, responseType: Types.ResourceResponseTypeEnum, medias?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, imageHotspots?: Array<{ mediaId: string, hotspots: Array<{ id: string, x: number, y: number }> }> | null } | null };


export type ExerciseQuestionResponseFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ExerciseQuestionResponseFragmentDoc = /*#__PURE__*/ gql`
    fragment ExerciseQuestionResponse on ExerciseQuestionResponseType {
  questionId
  responseType
  textResponse
  imageHotspotResponses {
    hotspots {
      id
      text
    }
  }
  response {
    ...EntityMedia
  }
  question {
    ...ExerciseQuestions
  }
}
    `;